import { Col, Form, VertInput } from "@vertem-core/vertice-ds";
import React from "react";

const PersonalData = () => (
  <>
    <Col lg={8} md={8} sm={24} xs={24}>
      <Form.Item name="documentNumber">
        <VertInput label="CPF" placeholder="CPF" disabled />
      </Form.Item>
    </Col>
    <Col lg={8} md={8} sm={24} xs={24}>
      <Form.Item name="name">
        <VertInput label="Nome completo" placeholder="Nome completo" disabled />
      </Form.Item>
    </Col>
  </>
);

export default PersonalData;
